export default [
    //FOR Finance Manager========================================================================
    {
        subject: "grns",
        gotApprovalProcess: false,
        key: "grns", //this is the parameter found in the url /form/:key 
        pageTitle: "GRN",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "grns",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                userId: "",
            },
            filterEndpoint: "myGRNS",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {  
                userId: "" // we set this on the fly
            }
        },
    }, 
    {
        subject: "allgrns",
        gotApprovalProcess: false,
        key: "allgrns", //this is the parameter found in the url /form/:key 
        pageTitle: "GRN",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "grns",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            // filter: { //remove January 30 2023, we want the procurement team to see all grn
            //     userId: "",
            // },
            filter: {
                userId: "",
            },
            filterEndpoint: "allGRNSForPRAccess",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            // additionalData: {  //remove January 30 2023, we want the procurement team to see all grn
            //     userId: "" // userId: ""  we set this on the fly
            // }
        },
    }, 

    //------------------------------------------------------------------------------------------
]